import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../../components/SEO';
import './YouthSummitSubPages.css';
import heroImg from '../../assets/YOCILAB Webiste photos/YOCILAB YOuth Summit/6.png';
import img2 from '../../assets/YOCILAB Webiste photos/YOCILAB YOuth Summit/DSC_4604.jpg';

const focusAreas = [
  'Youth Employment', 'Entrepreneurship', 'Education', 'Technology & AI',
  'Sustainable Agriculture', 'Financial Inclusion', 'Community Development', 'Environmental Sustainability'
];

const prizes = [
  {
    place: '1st', title: 'Grand Prize',
    reward: 'Cash Prize + 3-month incubation at YOCILAB + mentorship + media exposure',
    icon: (
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"/><path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"/><path d="M4 22h16"/><path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22"/><path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22"/><path d="M18 2H6v7a6 6 0 0 0 12 0V2z"/>
      </svg>
    ),
  },
  {
    place: '2nd', title: 'Runner-Up',
    reward: 'Cash Prize + 1-month business development support + partner connections',
    icon: (
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="8" r="6"/><path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11"/>
      </svg>
    ),
  },
  {
    place: '3rd', title: 'Third Place',
    reward: 'Cash Prize + YOCILAB Academy access + mentor sessions',
    icon: (
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="8" r="6"/><path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11"/>
      </svg>
    ),
  },
  {
    place: 'Special', title: 'Special Awards',
    reward: 'Best AI Solution · Most Socially Impactful · Best Pitch Presentation · People\'s Choice',
    icon: (
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
      </svg>
    ),
  },
];

const steps = [
  { step: '01', title: 'Challenge Launch', desc: 'Participants receive the official challenge brief and problem statements.' },
  { step: '02', title: 'Team Formation', desc: 'Multidisciplinary teams of 2–5 members are formed or confirmed.' },
  { step: '03', title: 'Innovation Sprint', desc: 'Teams collaborate and prototype through the night with workspace access.' },
  { step: '04', title: 'Mentorship Sessions', desc: 'Industry experts and tech veterans provide direct feedback and refinement.' },
  { step: '05', title: 'Final Presentations', desc: 'Teams pitch their solutions to a distinguished panel of judges.' },
  { step: '06', title: 'Awards & Incubation', desc: 'Outstanding teams receive catalytic cash prizes, mentorship, and incubator entry.' },
];

const InnovationChallenge = () => (
  <div className="sub-page">
    <SEO
      title="Innovation Challenge — YOCILAB Youth Summit 2026"
      description="An overnight innovation sprint where 20–30 teams tackle real-world challenges on 30th & 31st October 2026 at the YOCILAB Youth Summit in Bamenda."
    />

    {/* HERO */}
    <section className="sub-hero sub-hero--summit">
      <div className="sub-hero__bg">
        <img src={heroImg} alt="Innovation Challenge" className="sub-hero__img" />
        <div className="sub-hero__overlay" />
      </div>
      <div className="container">
        <div className="sub-hero__content">
          <Link to="/youth-summit" className="sub-hero__back">← Back to Summit</Link>
          <span className="sub-hero__tag">OVERNIGHT INNOVATION SPRINT</span>
          <h1 className="sub-hero__title">Innovation Challenge</h1>
          <p className="sub-hero__desc">
            Building Solutions for Africa's Future · Overnight Hack Night Sprint
          </p>
          <div className="sub-hero__meta-chips">
            <span className="meta-chip">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
              30th &amp; 31st October 2026
            </span>
            <span className="meta-chip">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/></svg>
              20–30 Teams
            </span>
            <span className="meta-chip">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="8" r="6"/><path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11"/></svg>
              Prizes + Incubation
            </span>
          </div>
        </div>
      </div>
    </section>

    {/* OVERVIEW */}
    <section className="sub-section">
      <div className="container">
        <div className="sub-two-col">
          <div className="sub-text">
            <span className="section-label">WHAT IS IT?</span>
            <h2 className="sub-section__title">Building Solutions for Africa's Future</h2>
            <p className="sub-body">
              The YOCILAB Innovation Challenge provides young people with an opportunity to work collaboratively, think creatively, and develop practical solutions to challenges affecting communities across Cameroon and Africa.
            </p>
            <p className="sub-body">
              Delivered through an overnight innovation sprint on 30th &amp; 31st October 2026, participants may arrive with an existing idea or create a new solution during the challenge itself. What matters is the quality and potential impact of the final solution.
            </p>
            <div className="sub-actions">
              <Link to="/youth-summit/register?type=challenge" className="sub-btn sub-btn--summit">
                Register Your Team
              </Link>
              <Link to="/contact" className="sub-btn sub-btn--outline-dark">
                Become a Challenge Partner
              </Link>
            </div>
          </div>
          <div className="sub-visual">
            <img src={img2} alt="Innovation teams" className="sub-img" loading="lazy" />
          </div>
        </div>
      </div>
    </section>

    {/* FOCUS AREAS */}
    <section className="sub-section sub-section--light">
      <div className="container">
        <div className="sub-header">
          <span className="section-label">KEY FOCUS AREAS</span>
          <h2 className="sub-section__title">Real-world impact domains</h2>
          <p className="sub-section__desc">Solutions can address urgent systemic challenges across these critical sectors.</p>
        </div>
        <div className="sub-tags-grid">
          {focusAreas.map((area) => (
            <div key={area} className="sub-tag-chip">
              <span className="sub-tag-chip__bullet" />
              <span>{area}</span>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* PROCESS */}
    <section className="sub-section">
      <div className="container">
        <div className="sub-header">
          <span className="section-label">HOW IT WORKS</span>
          <h2 className="sub-section__title">From challenge brief to stage pitch</h2>
        </div>
        <div className="sub-process-steps">
          {steps.map((s) => (
            <div key={s.step} className="sub-process-step">
              <span className="sub-process-step__number">{s.step}</span>
              <div>
                <h3 className="sub-process-step__title">{s.title}</h3>
                <p className="sub-process-step__desc">{s.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* WHY IT MATTERS & PARTICIPATION */}
    <section className="sub-section sub-section--summit-dark">
      <div className="container">
        <div className="sub-two-col">
          <div className="sub-text">
            <span className="section-label section-label--white">WHY IT MATTERS</span>
            <h2 className="sub-section__title" style={{ color: '#fff' }}>Move beyond discussing problems to creating solutions</h2>
            <p className="sub-body" style={{ color: 'rgba(255,255,255,0.85)' }}>
              The Innovation Challenge promotes creativity, teamwork, critical thinking, leadership, and innovation. It proves that African youth are equipped to build scalable solutions when provided the platform, mentorship, and belief.
            </p>
          </div>
          <div className="sub-text" style={{ background: 'rgba(255,255,255,0.06)', padding: '32px', borderRadius: '20px', border: '1px solid rgba(255,255,255,0.1)' }}>
            <h3 style={{ color: 'var(--color-accent)', marginBottom: '12px' }}>Participation is Free</h3>
            <p style={{ color: 'rgba(255,255,255,0.85)', fontSize: '0.95rem', marginBottom: '20px' }}>
              Participation in the Innovation Challenge is completely free for all registered Summit delegates. Register individually or as a complete team for 30th &amp; 31st October 2026.
            </p>
            <Link to="/youth-summit/register?type=challenge" className="sub-btn sub-btn--accent">
              Register Team for Hack Night
            </Link>
          </div>
        </div>
      </div>
    </section>

    {/* PRIZES */}
    <section className="sub-section">
      <div className="container">
        <div className="sub-header">
          <span className="section-label">PRIZES &amp; REWARDS</span>
          <h2 className="sub-section__title">More than a trophy</h2>
          <p className="sub-section__desc">Winners gain real opportunity — funding pathways, incubation, mentorship, and a platform to launch.</p>
        </div>
        <div className="sub-grid-4">
          {prizes.map((p) => (
            <div key={p.place} className="sub-prize-card">
              <div className="sub-prize-card__icon">{p.icon}</div>
              <span className="sub-prize-card__place">{p.place} Place</span>
              <h3 className="sub-prize-card__title">{p.title}</h3>
              <p className="sub-prize-card__reward">{p.reward}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* NAV STRIP */}
    <section className="sub-nav-strip summit-nav-strip">
      <div className="container">
        <div className="sub-nav-strip__grid">
          <Link to="/youth-summit/summit-experience" className="sub-nav-card">
            <span className="sub-nav-card__label">Before</span>
            <span className="sub-nav-card__title">← Summit Experience</span>
          </Link>
          <Link to="/youth-summit/fellowship" className="sub-nav-card">
            <span className="sub-nav-card__label">After</span>
            <span className="sub-nav-card__title">YOCILAB Fellowship →</span>
          </Link>
          <Link to="/youth-summit/register?type=challenge" className="sub-nav-card sub-nav-card--cta">
            <span className="sub-nav-card__label">Join the Challenge</span>
            <span className="sub-nav-card__title">Register Your Team →</span>
          </Link>
        </div>
      </div>
    </section>
  </div>
);

export default InnovationChallenge;
